export default "__VITE_ASSET__BUlZu7S0__"